// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-details-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.template-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.template-details-header h1 {
  margin: 0;
  color: #333;
}

.template-actions {
  display: flex;
  gap: 10px;
}

.btn-primary {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.btn-secondary {
  background-color: #f8f9fa;
  color: #333;
  border: 1px solid #ddd;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  text-decoration: none;
  transition: background-color 0.2s;
}

.btn-secondary:hover {
  background-color: #e9ecef;
}

.btn-danger {
  background-color: #f8f9fa;
  color: #e74c3c;
  border: 1px solid #e74c3c;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s, color 0.2s;
}

.btn-danger:hover {
  background-color: #e74c3c;
  color: white;
}

.template-details-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.template-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.info-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-label {
  font-weight: bold;
  color: #555;
}

.badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.badge-email {
  background-color: #e3f2fd;
  color: #1976d2;
}

.badge-sms {
  background-color: #e8f5e9;
  color: #388e3c;
}

.badge-category {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.template-content-section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.template-subject {
  margin-bottom: 20px;
}

.template-subject h3 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
  font-size: 18px;
}

.subject-content {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #eee;
  font-size: 16px;
}

.template-content h3 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
  font-size: 18px;
}

.content-container {
  margin-bottom: 20px;
}

.email-content pre,
.sms-content pre {
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #eee;
  overflow-x: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 20px 0;
}

.content-divider {
  height: 1px;
  background-color: #eee;
  margin: 20px 0;
}

.email-content h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
}

.html-preview {
  padding: 20px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: white;
  min-height: 200px;
}

.template-placeholders {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.template-placeholders h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 18px;
}

.placeholders-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  padding-left: 0;
  list-style-type: none;
}

.placeholders-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  font-size: 14px;
}

.placeholders-list code {
  background-color: #e9ecef;
  padding: 2px 4px;
  border-radius: 3px;
  font-family: monospace;
  color: #e74c3c;
}

.loading {
  text-align: center;
  padding: 30px;
  color: #666;
  font-style: italic;
}

.error-message {
  background-color: #ffebee;
  color: #c62828;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  border-left: 4px solid #c62828;
}

/* Responsive design */
@media (max-width: 768px) {
  .template-details-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .template-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .placeholders-list {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TemplateDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".template-details-container {\n  padding: 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.template-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.template-details-header h1 {\n  margin: 0;\n  color: #333;\n}\n\n.template-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-primary {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  text-decoration: none;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #2980b9;\n}\n\n.btn-secondary {\n  background-color: #f8f9fa;\n  color: #333;\n  border: 1px solid #ddd;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  text-decoration: none;\n  transition: background-color 0.2s;\n}\n\n.btn-secondary:hover {\n  background-color: #e9ecef;\n}\n\n.btn-danger {\n  background-color: #f8f9fa;\n  color: #e74c3c;\n  border: 1px solid #e74c3c;\n  padding: 10px 15px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.btn-danger:hover {\n  background-color: #e74c3c;\n  color: white;\n}\n\n.template-details-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.template-info {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.info-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.info-label {\n  font-weight: bold;\n  color: #555;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.badge-email {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.badge-sms {\n  background-color: #e8f5e9;\n  color: #388e3c;\n}\n\n.badge-category {\n  background-color: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.template-content-section {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.template-subject {\n  margin-bottom: 20px;\n}\n\n.template-subject h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #333;\n  font-size: 18px;\n}\n\n.subject-content {\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #eee;\n  font-size: 16px;\n}\n\n.template-content h3 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #333;\n  font-size: 18px;\n}\n\n.content-container {\n  margin-bottom: 20px;\n}\n\n.email-content pre,\n.sms-content pre {\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #eee;\n  overflow-x: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: monospace;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0 0 20px 0;\n}\n\n.content-divider {\n  height: 1px;\n  background-color: #eee;\n  margin: 20px 0;\n}\n\n.email-content h4 {\n  margin-top: 0;\n  margin-bottom: 10px;\n  color: #333;\n  font-size: 16px;\n}\n\n.html-preview {\n  padding: 20px;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  background-color: white;\n  min-height: 200px;\n}\n\n.template-placeholders {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.template-placeholders h3 {\n  margin-top: 0;\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 18px;\n}\n\n.placeholders-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 10px;\n  padding-left: 0;\n  list-style-type: none;\n}\n\n.placeholders-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.placeholders-list code {\n  background-color: #e9ecef;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-family: monospace;\n  color: #e74c3c;\n}\n\n.loading {\n  text-align: center;\n  padding: 30px;\n  color: #666;\n  font-style: italic;\n}\n\n.error-message {\n  background-color: #ffebee;\n  color: #c62828;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  border-left: 4px solid #c62828;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .template-details-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .template-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .placeholders-list {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
